import type { MotnStreamingOption } from '@setplex/tria-api'
import type { TFunction } from 'i18next'

export type MotnStreamingOptionRow = {
  serviceName: string
  subtitle: string
  logoUrl?: string
  link?: string
  quality?: string | null
  accessInfo?: string | null
}

function subtitleFromAccess(option: MotnStreamingOption, t: TFunction): string {
  const access = option.accessInfo
  const price = option.price?.trim() ?? ''

  switch (access) {
    case 'buy':
      return price ? t('external_source_buy', { price }) : t('buy')
    case 'rent':
      return price ? t('external_source_rent', { price }) : t('rent')
    case 'addon':
      return t('external_source_addon', { name: option.addon ?? '' })
    case 'subscription':
      return t('settings_subscription')
    case 'free':
      return t('external_source_free')
    default:
      return ''
  }
}

export function normalizeMotnStreamingOptions(
  raw: MotnStreamingOption[],
  t: TFunction
): MotnStreamingOptionRow[] {
  return raw.map((option) => ({
    serviceName: option.serviceName ?? '',
    subtitle: subtitleFromAccess(option, t),
    logoUrl:
      option.serviceLogo?.darkThemeImage ?? option.serviceLogo?.lightThemeImage,
    link: option.link,
    quality: option.quality,
    accessInfo: option.accessInfo,
  }))
}
